import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export interface DeclineClosingDateProposalArg {
    engagementId: number;
    proposalId: string;
    comment: string;
}

export const DeclineClosingDateProposal = createAsyncThunk(
    'closingDate/decline',
    async (arg: DeclineClosingDateProposalArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${arg.engagementId}/ClosingDate/Proposals/${arg.proposalId}/Decline`,
            { comment: arg.comment }
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while declining the closing date proposal.';
            createNotification(message, 'error');
            throw new Error('Failed to decline closing date proposal');
        }

        createNotification('Closing date proposal declined.', 'success');
        return response.data as EngagementClosingDate;
    }
);
